import { InteractiveTileDataType } from '@app-store'
import { SvgInfoIcon, SvgLongBar, Tooltip } from '@ui-kit'
import { buildSubCounts, getTotalFromObject } from '../../utils/helperFunctions'
import { DASHBOARD } from '../../utils/constants'

export const InteractiveTile = ({
  tileName,
  total,
  border,
  selected,
  onStatusCardClick,
  onSubCountClick,
  message,
  selectedTile,
  selectedSubCount,
}: InteractiveTileDataType) => {
  const finalSubCounts =
    typeof total === 'string' ? null : buildSubCounts(total)
  return (
    <div
      className={`min-w-[14rem] min-h-[4.8rem] px-2 rounded-t shadow-[6px_6px_54px_0px_rgba(0,0,0,0.05)]  cursor-pointer flex flex-col overflow-x-auto ${
        selectedTile === tileName ? selected : border
      } ${
        tileName !== DASHBOARD.ALL_CASES
          ? selectedTile === tileName
            ? `${selected} py-1`
            : `${border}  py-1`
          : 'bg-blue-50'
      }`}
      onClick={() => {
        if (tileName !== DASHBOARD.ALL_CASES && onStatusCardClick) {
          if (selectedTile === tileName) {
            onStatusCardClick('', total)
          } else {
            onStatusCardClick(tileName, total)
          }
        }
      }}
    >
      {tileName !== DASHBOARD.ALL_CASES ? (
        <TileItem1 tileName={tileName} message={message} total={total} />
      ) : (
        <TileItem2
          finalSubCounts={
            finalSubCounts as
              | {
                  label: string
                  value: string
                }[]
              | null
          }
          onSubCountClick={onSubCountClick}
          selectedSubCount={selectedSubCount}
        />
      )}
    </div>
  )
}

const TileItem1 = ({
  tileName,
  message,
  total,
}: {
  tileName: string
  message?: string
  total: string | number | Record<string, number>
}) => {
  return (
    <div className="flex flex-col justify-between min-h-[4rem]">
      {/* Title Row */}
      <div className="flex items-center">
        <span className="text-sm font-primary font-medium text-accent-900">
          {tileName}
        </span>
        {message && (
          <span className="text-accent-500 text-xs ml-2 cursor-pointer">
            <Tooltip content={message}>
              <SvgInfoIcon />
            </Tooltip>
          </span>
        )}
      </div>
      <div className="flex items-center justify-between">
        {/* Main Count */}
        <div
          className={`text-[1.5rem] leading-none font-semibold text-accent-900`}
        >
          {typeof total === 'string'
            ? total
            : String(
                getTotalFromObject(total as Record<string, number> | undefined)
              )}
        </div>
      </div>
    </div>
  )
}

const TileItem2 = ({
  finalSubCounts = [],
  onSubCountClick,
  selectedSubCount,
}: {
  finalSubCounts:
    | {
        label: string
        value: string
      }[]
    | null
  onSubCountClick?: (type: string) => void
  selectedSubCount?: string
}) => {
  if (!finalSubCounts || !finalSubCounts.length) return null

  const columnCount = Math.ceil(finalSubCounts.length / 3)

  const columns = Array.from({ length: columnCount }, (_, colIndex) =>
    finalSubCounts.slice(colIndex * 3, colIndex * 3 + 3)
  )

  return (
    <div
      className="grid gap-6 my-auto"
      style={{
        gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
      }}
    >
      {columns.map((columnItems, colIndex) => (
        <div key={colIndex} className="flex items-start gap-6">
          {/* Column */}
          <div className="flex flex-col w-full">
            {columnItems.map(({ label, value }) => (
              <button
                key={label}
                onClick={(e) => {
                  e.stopPropagation()
                  if (selectedSubCount === label) {
                    onSubCountClick?.('')
                  } else {
                    onSubCountClick?.(label)
                  }
                }}
                className={`flex items-center justify-between px-2 py-1 rounded w-full 
                  ${
                    selectedSubCount === label
                      ? 'bg-blue-100 font-bold'
                      : 'hover:bg-blue-100 font-medium'
                  }`}
              >
                <span className="text-xs  text-accent-700">{label}</span>
                <span className="text-xs text-accent-900">{value}</span>
              </button>
            ))}
          </div>

          {/* Divider */}
          {colIndex !== columnCount - 1 && (
            <div className="flex items-stretch my-auto">
              <SvgLongBar />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
